'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StarIcon = function StarIcon(_ref) {
  var style = _ref.style,
      lg = _ref.lg;
  return _react2.default.createElement(_styled2.default.StarIcon, {
    xmlns: 'http://www.w3.org/2000/svg',
    version: '1.1',
    viewBox: '0 0 24 24',
    className: 'icon',
    style: style,
    lg: lg
  }, _react2.default.createElement('path', {
    fill: 'currentColor',
    d: 'M13.5098 3.13924C12.8578 1.95424 11.1418 1.95424 10.4888 3.13924C9.63009 4.69962 8.92221 6.33838 8.3748 8.03324C8.34899 8.09955 8.30357 8.15641 8.24462 8.19625C8.18566 8.2361 8.11596 8.25702 8.0448 8.25624C6.57777 8.29437 5.11551 8.44009 3.6698 8.69224C2.3328 8.92524 1.7438 10.5292 2.7598 11.5222C2.8878 11.6476 3.01714 11.7722 3.1478 11.8962C4.12662 12.8231 5.16301 13.6871 6.2508 14.4832C6.30022 14.516 6.33766 14.564 6.3575 14.6199C6.37733 14.6758 6.37849 14.7366 6.3608 14.7932C5.81164 16.4409 5.41924 18.1368 5.1888 19.8582C4.9988 21.2822 6.5068 22.1562 7.6838 21.5522C9.11268 20.8199 10.4789 19.9714 11.7688 19.0152C11.8364 18.9675 11.9171 18.9418 11.9998 18.9418C12.0825 18.9418 12.1633 18.9675 12.2308 19.0152C13.5199 19.9725 14.8863 20.8211 16.3158 21.5522C17.4928 22.1562 19.0008 21.2822 18.8108 19.8582C18.5807 18.1368 18.1886 16.441 17.6398 14.7932C17.6221 14.7366 17.6233 14.6758 17.6431 14.6199C17.6629 14.564 17.7004 14.516 17.7498 14.4832C18.9823 13.5811 20.1486 12.5919 21.2398 11.5232C22.2558 10.5292 21.6668 8.92524 20.3298 8.69224C18.8838 8.44005 17.4212 8.29432 15.9538 8.25624C15.8828 8.25682 15.8133 8.2358 15.7546 8.19597C15.6958 8.15614 15.6506 8.09939 15.6248 8.03324C15.0791 6.33773 14.3702 4.69881 13.5098 3.13924Z'
  }));
};

exports.default = StarIcon;